package com.rajen.angrejidictionary.util

import kotlinx.browser.window
import kotlinx.coroutines.await

/** Best-effort clipboard write — returns false rather than throwing if the browser denies permission. */
suspend fun writeClipboardText(text: String): Boolean = try {
    val promise = window.navigator.asDynamic().clipboard?.writeText(text)
    if (promise != null) {
        (promise as kotlin.js.Promise<Unit>).await()
        true
    } else false
} catch (_: Throwable) {
    false
}

/** Best-effort clipboard read — returns null rather than throwing if the browser denies permission. */
suspend fun readClipboardText(): String? = try {
    val promise = window.navigator.asDynamic().clipboard?.readText()
    (promise as? kotlin.js.Promise<String>)?.await()
} catch (_: Throwable) {
    null
}
